export const compactSearchFilters = (filters = {}) =>
  Object.fromEntries(
    Object.entries(filters).filter(([, value]) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== null && value !== undefined && value !== "";
    }),
  );

export const buildSearchParams = (filters = {}) => {
  const params = new URLSearchParams();

  Object.entries(compactSearchFilters(filters)).forEach(([key, value]) => {
    const values = Array.isArray(value) ? value : [value];
    values.forEach((item) => params.append(key, String(item)));
  });

  return params;
};

export const parseSearchParams = (queryString = "") => {
  const params = new URLSearchParams(queryString);
  const filters = {};

  params.forEach((value, key) => {
    if (filters[key] === undefined) {
      filters[key] = value;
    } else if (Array.isArray(filters[key])) {
      filters[key].push(value);
    } else {
      filters[key] = [filters[key], value];
    }
  });

  return filters;
};
